
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login-link",
      function () {
        return require("private-next-pages/login-link/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login-link"])
      });
    }
  